export default "__VITE_ASSET__DgiXQyEV__"